import LoadingSpinner from '../components/LoadingSpinner.js'
import HeroList from '../components/HeroList.js';
export default class HeroesPage{
    constructor(app, params){
        this.app = app;
        this.params = params;
    }

    async mount(container) {
        this.container = container;
        this.render();
    }

    render(){
        this.container. innerHTML = `
            <div id="hero-page">
                <div id="loading"></div>
                <div id="hero-list"></div>
            </div>
        `;
        this.renderHeroList();
    }

    async renderHeroList(){

        this.app.telegram.tg.BackButton.show();
        // this.app.pathStory.push('/heroes');

        const clickHandler = (id)=> {
            this.app.api.heroID = id;
            this.app.router.navigate(`/stories`);
        }

        // const universeID = this.app.router.lastResolved();
        // console.log("universeID", this.app.router.getCurrentRoute());
        
        const heroList = this.container.querySelector('#hero-list');
        const heroesJSON = await this.app.api.getHeroesByUnID();
        const heroListComponent = new HeroList({
            heroes: heroesJSON,
            clickHandler: clickHandler
        });
        heroListComponent.render(heroList);
    }

}